import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Introduction.scss';
import intro_img  from '../../../assets/logo/about-reception.png';
import intro_img_2 from '../../../assets/logo/slider4.jpg';
import introside_img from '../../../assets/logo/aquabook.JPG';
import serviceicon from "../../../assets/logo/sec-title-icon.jpg";
const introvid = "/videos/waterpark.mp4";

const Introduction = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    const videoWindow = window.open('', '_blank');

    if (videoWindow) {
      videoWindow.document.write(`
        <html>
          <head><title>The Grand Machal</title></head>
          <body style="margin:0; background:#000; display:flex; justify-content:center; align-items:center; height:100vh;">
            <video width="100%" controls autoplay muted>
              <source src="${introvid}" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </body>
        </html>
      `);
      videoWindow.document.close();
      setIsPlaying(true);
    } else {
      alert('Popup blocked! Please allow popups for this site.');
    }
  };

  return (
    <>
      <div className="service_title1">
        <div className="service_title">
          <img src={serviceicon} alt=''/>
          <h5 style={{textTransform:'capitalize'}}>The Grand Machal Introduction</h5>
          <h1>Adventure | Accommodation | Restaurant | Wedding & Events</h1>
        </div>
      </div> 
      <div className="intro"> 
        <div className="intro-right">
            <h3>The Grand Machal is a kaleidoscope of natural wonders, adventures, sports, resort, and eateries.</h3>
            <p>
              Welcome to <b>The Grand Machal</b> — Central India’s ultimate family adventure destination, where fun meets nature and every visit feels like a celebration!<br></br>
              Spread across acres of scenic greenery, TGM is a vibrant man-made jungle that brings together adventure, leisure, learning, and relaxation in one magical place. From thrilling rides and outdoor sports to our refreshing <b> water park </b>, peaceful <b>resort villas</b>, and delightful eateries — every moment here is designed for joy, bonding, and discovery.<br></br>
              At <b>The Grand Machal</b>, happiness takes many forms — exploring our <b>Science Park </b> that ignites young curiosity, strolling through our <b> organic farms </b>that reconnect you with nature, or simply unwinding in our serene landscapes. Every experience is crafted to create lasting memories for families and friends alike.<br></br>
              Guided by our motto<b> “Peace & Joy” </b>, we believe in offering more than just recreation — we create experiences that stay with you. Whether it’s a weekend getaway, a school trip, or a grand <b>destination wedding </b>, TGM offers the perfect blend of natural beauty, adventure, and world-class hospitality.
            </p>
             <p>  Conveniently located near Indore:	 </p>
              <ul className="about-one__content-list">
                <li>
                  <div className="icon"><i className="fa fa-check-circle" aria-hidden="true"></i></div>
                  <div className="text"><p>19 km (approx.) from Devi Ahilyabai Holkar International Airport.</p></div>
                </li>
                <li>
                  <div className="icon"><i className="fa fa-check-circle" aria-hidden="true"></i></div>
                  <div className="text"><p>22 km (approx.) from Indore Railway Station.</p></div>
                </li>
              </ul>
              <p>Come experience the beauty of nature, the thrill of adventure, and the comfort of luxury — only at The Grand Machal.</p>
          </div>
      {/* Video section */}
        {/*  <div className="intro_img2">
         <div className="intro_imgside-wrapper">
             <img src={introside_img} alt="Overlay" className="intro_imgside" /> 
            {!isPlaying && (
              <div className="video-overlay" onClick={handlePlay}>
                <div className="play-button">&#9658;</div>
              </div>
            )}
          </div> 
        </div>*/}
    </div>
  </>
  );
};

export default Introduction;